import React from "react";
//#region types
import { SettingsLayoutProps } from "models/propTypes/pageLayoutPropTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
import NavigationLayout from "./navigationLayout/navLayout";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const SettingsLayout: React.FC<SettingsLayoutProps> = (props) => {
  return (
    <Grid container direction={"column"} spacing={3} className={cssExports.settingsLayout}>
      <Grid item container>
        <Grid item xs className={cssExports.dashboardHeaderText}>
          {props.title}
        </Grid>
      </Grid>
      <NavigationLayout
        onMenuItemSelectHandler={props.onMenuItemSelectHandler}
        navItems={props.navItems}
      ></NavigationLayout>
    </Grid>
  );
};

export default SettingsLayout;
